/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading} from '../Loading/LoadingSlice'
import {fetchAsyncUserDetails} from '../../../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {ENV} from '../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  quickMms: {},
}

export const fetchAsyncQuickMms: any = createAsyncThunk(
  'quickMms/fetchAsyncQuickMms',
  async (data, thunkApi) => {
    const response = await axios.post(`${API_URL}gatewaymms`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(fetchAsyncUserDetails())
    return response.data
  }
)

const quickMmsSlice = createSlice({
  name: 'quickMMS',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncQuickMms.pending]: (state) => {},
    [fetchAsyncQuickMms.fulfilled]: (state, {payload}) => {
      {
        payload.status === true && toast.success(payload.message)
      }
      return {...state, quickMms: payload}
    },
    [fetchAsyncQuickMms.rejected]: () => {},
  },
})

export default quickMmsSlice.reducer
